import React from "react";
import LegalPage from "@/components/LegalPage";
import { Mail } from "lucide-react";

export default function Contact() {
  return (
    <LegalPage
      title="Get in touch"
      lastUpdated="May 21, 2026"
      testid="contact-page"
    >
      <p>
        Colleague is built by a small team that actually reads its email. If
        you have a question, a refund request, a privacy concern, a bug, or
        just something you want to say — we'd like to hear it.
      </p>

      <div className="bg-white border border-[#E6E2D8] rounded-2xl p-6 mt-6 not-prose">
        <div className="flex items-start gap-3">
          <Mail
            size={20}
            strokeWidth={1.5}
            className="text-[#D4A574] mt-1 flex-shrink-0"
          />
          <div>
            <p className="text-sm uppercase tracking-wider text-[#9A938A]">
              Email
            </p>
            <a
              href="mailto:hello@meetacolleague.com"
              data-testid="contact-email"
              className="font-serif text-2xl text-[#2D2926] hover:text-[#D4A574] transition-colors"
            >
              hello@meetacolleague.com
            </a>
            <p className="mt-2 text-sm text-[#6B655D]">
              We respond within 3 business days, usually faster.
            </p>
          </div>
        </div>
      </div>

      <h2 className="font-serif text-2xl text-[#2D2926] mt-10">
        Helpful subject lines
      </h2>
      <p>
        These help us get to you faster. Not required — just helpful.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li><strong>refund please</strong> — for a refund within 7 days of purchase</li>
        <li><strong>delete my account</strong> — to permanently remove your data</li>
        <li><strong>privacy question</strong> — GDPR / CCPA / data export</li>
        <li><strong>bug</strong> — something's broken</li>
        <li><strong>feature idea</strong> — yes we read every one</li>
        <li><strong>partnership</strong> — if you build something complementary</li>
      </ul>

      <h2 className="font-serif text-2xl text-[#2D2926] mt-10">
        Crisis resources
      </h2>
      <p>
        Colleague is not a substitute for professional support. If you or
        someone you care about is in immediate distress:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>United States</strong>: 988 (Suicide & Crisis Lifeline) — call or text
        </li>
        <li>
          <strong>United Kingdom</strong>: 116 123 (Samaritans)
        </li>
        <li>
          <strong>International</strong>:{" "}
          <a
            href="https://findahelpline.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#D4A574] hover:text-[#C99560] underline"
          >
            findahelpline.com
          </a>
        </li>
      </ul>
    </LegalPage>
  );
}
